export const NAME = 'InterniProdej';
